import { initializeApp } from 'firebase/app'
import { getStorage } from 'firebase/storage'
import { getDatabase } from 'firebase/database'
import { getAuth } from 'firebase/auth'

// Your web app's Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCRKabzH7kjLCDzLfV607VxM5lYKaVuG_c",
  authDomain: "virtualtours-980ac.firebaseapp.com",
  databaseURL: "https://virtualtours-980ac-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "virtualtours-980ac",
  storageBucket: "virtualtours-980ac.firebasestorage.app",
  messagingSenderId: "27774400802",
  appId: "1:27774400802:web:165ca32a48e2d006ad0d7b",
  measurementId: "G-JFTY5WMKZ3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
export const storage = getStorage(app)
export const database = getDatabase(app)
export const auth = getAuth(app)
export default app
